import { render, staticRenderFns } from "./TaskOnboardeeList.vue?vue&type=template&id=2226e2e8&scoped=true"
import script from "./TaskOnboardeeList.vue?vue&type=script&lang=js"
export * from "./TaskOnboardeeList.vue?vue&type=script&lang=js"
import style0 from "./TaskOnboardeeList.vue?vue&type=style&index=0&id=2226e2e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2226e2e8",
  null
  
)

export default component.exports